<button mat-icon-button class="{{label ? 'labeled-actions-buttons' : 'actions-buttons'}}" (click)="clearThreads()">
    <mat-icon matTooltip="Clear Threads" class="{{label ? '' : 'actions-mat-icons'}}">clear_all</mat-icon>
    <span *ngIf="label">{{label}}</span>
</button>
